const middleware = {}

middleware['redirect'] = require('../middleware/redirect.ts')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

middleware['section-access'] = require('../middleware/section-access.ts')
middleware['section-access'] = middleware['section-access'].default || middleware['section-access']

export default middleware
